/* eslint-disable local/no-raw-colors */
import React from 'react'
import type { SvgProps } from 'react-native-svg'
import { ClipPath, Defs, G, Path, Rect, Svg } from 'react-native-svg'

export const FirefighterRescueUnit: React.FC<SvgProps> = props => (
    <Svg viewBox='0 0 40 40' {...props}>
        <Rect x='0.5' y='0.5' rx='19.5' stroke='#E5E5E6' />
        <G clipPath='url(#clip0_4099_4515)'>
            <Path
                d='M30.9 18.69L29.46 14.37C29.18 13.55 28.42 13 27.56 13H27V12C27 11.45 26.55 11 26 11H25C24.45 11 24 11.45 24 12V13H22C20.9 13 20 13.9 20 15V19H9V24C9 25.1 9.9 26 11 26H12C12 27.66 13.34 29 15 29C16.66 29 18 27.66 18 26H22C22 27.66 23.34 29 25 29C26.66 29 28 27.66 28 26H31V19.32C31 19.11 30.97 18.9 30.9 18.69ZM15 27C14.45 27 14 26.55 14 26C14 25.45 14.45 25 15 25C15.55 25 16 25.45 16 26C16 26.55 15.55 27 15 27ZM25 27C24.45 27 24 26.55 24 26C24 25.45 24.45 25 25 25C25.55 25 26 25.45 26 26C26 26.55 25.55 27 25 27ZM22 19V15H27.56L28.89 19H22Z'
                fill='#E5E5E6'
            />
            <Path
                d='M19 16.5H18V14.5H19V13H9V14.5H10V16.5H9V18H19V16.5ZM13.25 16.5H11.5V14.5H13.25V16.5ZM16.5 16.5H14.75V14.5H16.5V16.5Z'
                fill='#E5E5E6'
            />
        </G>
        <Defs>
            <ClipPath id='clip0_4099_4515'>
                <Rect fill='white' transform='translate(8 8)' />
            </ClipPath>
        </Defs>
    </Svg>
)
